// Module
var code = "<div class=\"md-whiteframe-z1 mn-module flex layout-column\" ui-view>\n</div>\n";
// Exports
module.exports = code;